import React, { useEffect, useMemo } from "react";
import { AppHelpers, HierarchyAPI } from "@ai360/core";

import { OrgLevelSearch } from "~/admin/agBytes/components/org-level-search";
import { Section, SubSection } from "~/core";
import { fetchDropdownData } from "~/core/dropdowns/actions";
import { useAppDispatch, useAppSelector } from "~/store/hooks";

import { getDropdowns } from "./../../selectors";

const PROPS_ORG_LEVEL_PARENT = "orgLevelParents";
const DELIMITER = " > ";
const ORG_LEVEL_KEY = "orgLevel";

type HierarchyFilterProps = {
    filterToLastUsedLocation?: boolean;
    onFilterChange: (selected: string[]) => void;
    placeholderText?: string;
    selectedCompanyUserGuid?: string;
};

export const HierarchyFilter = ({
    filterToLastUsedLocation = true,
    onFilterChange,
    placeholderText,
    selectedCompanyUserGuid,
}: HierarchyFilterProps) => {
    const dispatch = useAppDispatch();
    const dropdowns = useAppSelector((state) => getDropdowns([ORG_LEVEL_KEY], state));

    useEffect(() => {
        const url = filterToLastUsedLocation
            ? HierarchyAPI.REQUEST_ORG_LEVEL_WITH_PARENTS
            : HierarchyAPI.REQUEST_ORG_LEVEL_WITH_PARENTS_UNFILTERED;
        dispatch(
            fetchDropdownData({
                [ORG_LEVEL_KEY]: {
                    url,
                    model: selectedCompanyUserGuid,
                },
            })
        );
    }, [filterToLastUsedLocation, selectedCompanyUserGuid, dispatch]);

    const items = useMemo(() => {
        return AppHelpers.parseOrgLevelList(
            dropdowns[ORG_LEVEL_KEY] || [],
            PROPS_ORG_LEVEL_PARENT,
            DELIMITER,
            null
        );
    }, [dropdowns]);

    return (
        <Section className="hierarchy-filter-container">
            <SubSection>
                <OrgLevelSearch
                    itemList={items}
                    onSelection={onFilterChange}
                    placeholderText={placeholderText}
                />
            </SubSection>
        </Section>
    );
};

export default HierarchyFilter;
